import { useCallback, useState } from 'react';
import { UseDataProps } from './types';
import { useStore } from '30.quickConnect.Stores';
import { isSameOuCode } from '80.quickConnect.Core/helpers/organizationalUnits/ouCode';

const useData = (): UseDataProps => {
  const {
    LoginStore: { isMultiOUUser, effectiveOuCode, ouTree, setCurrentOuCode, getUserOrganizationnalUnits },
  } = useStore();

  const [ouMenuAnchorEl, setOuMenuAnchorEl] = useState<null | HTMLElement>(null);
  const ouMenuOpen = Boolean(ouMenuAnchorEl);

  const handleOuMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setOuMenuAnchorEl(event.currentTarget);
      void getUserOrganizationnalUnits();
    },
    [getUserOrganizationnalUnits],
  );
  const handleOuMenuClose = useCallback(() => {
    setOuMenuAnchorEl(null);
  }, []);
  const handleOuMenuMoveTo = useCallback(
    (ouCode: string) => {
      // UO retirée entre-temps par le rechargement des UO de l'utilisateur : sélection ignorée
      if (ouTree.contains(ouCode)) {
        setCurrentOuCode(ouCode);
        // Synchronise l'UO courante avec les autres onglets
        window.dispatchEvent(new Event('storage'));
      }
      setOuMenuAnchorEl(null);
    },
    [ouTree, setCurrentOuCode],
  );
  const isCurrentOu = useCallback((ouCode: string) => isSameOuCode(ouCode, effectiveOuCode), [effectiveOuCode]);

  return {
    ouMenuOpen,
    ouMenuAnchorEl,
    isMultiOUUser: isMultiOUUser(),
    ouRoots: ouTree.getRoots(),
    currentOu: ouTree.getNode(effectiveOuCode),
    // Seul le chemin vers l'UO courante est déplié
    expandedCodes: ouTree.getCodesToExpandFor(effectiveOuCode),
    isCurrentOu,
    handleOuMenuClick,
    handleOuMenuClose,
    handleOuMenuMoveTo,
  };
};

export default useData;
